<template>
  <!-- 搜索框 -->
  <div class="search-box">
    <el-input
      size="small"
      style="width: 300px; margin-right: 10px"
      v-model.trim="value"
      clearable
      @keyup.13.native="onSearch"
      @input="inputChange"
    />
    <el-button type="primary" size="small" @click="onSearch">查询</el-button>
    <el-button type="primary" size="small" @click="onReset">清空</el-button>
    <el-button
      size="small"
      type="text"
      icon="el-icon-shopping-cart-full"
      @click="toShoppingCar"
      >我的购物车
    </el-button>
    <span
      >(<b>{{ total }}</b
      >)</span
    >
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  components: {},
  data: () => ({
    value: '',
  }),
  computed: {
    ...mapState({
      total: state => state.addSampleToCart.shoppingCartNum,
    }),
  },
  methods: {
    inputChange(val) {
      this.$emit('input-change', val);
    },
    onSearch() {
      this.$emit('on-search', this.value);
    },
    onReset() {
      this.value = '';
      this.$emit('on-reset', '');
    },
    toShoppingCar() {
      this.$store.dispatch('tagsView/jumpAndClosePage', {
        open: {
          name: '我的购物车',
          href: '/cml-shopping-cart',
        },
      });
      this.$router.push({
        name: 'cml-shopping-cart',
        params: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search-box {
  display: flex;
  align-items: center;
  .el-button--text {
    color: #333;
    font-size: 16px;
    margin-left: 20px;
    &:hover {
      color: #AB0033;
    }
  }
  /deep/ .el-icon-shopping-cart-full {
    font-size: 24px;
    color: #AB0033;
  }
  span {
    padding-top: 8px;
    color: #AB0033;
  }
}
</style>
